module.exports = __webpack_public_path__ + "img/attractions-pool.2e31e8d5.jpg";